var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteractionDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 5,
    fill: "#F7971E",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 57.5,
    height: 57.5,
    rx: 4.75,
    stroke: "#2A85FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8329 15.0004C42.1345 15.0004 43.9994 16.8652 43.9994 19.1668V29.9997C43.9994 30.9196 43.2528 31.6662 42.3329 31.6662C41.4128 31.6662 40.6662 30.9196 40.6662 29.9997V25.8332C40.6662 25.3733 40.2929 25 39.8329 25H18.1665C17.7065 25 17.3332 25.3733 17.3332 25.8332V40.8328C17.3332 41.291 17.7082 41.666 18.1665 41.666H29.068C29.9597 41.666 30.6878 42.3794 30.7012 43.271C30.7012 43.2943 30.7012 43.316 30.7029 43.3393C30.7161 44.251 29.9811 44.9993 29.0696 44.9993H18.1665C15.8649 44.9993 14 43.1344 14 40.8328V19.1665C14 16.8649 15.8649 15 18.1665 15L39.8329 15.0004ZM31.3399 34.3631C31.0348 33.1415 32.1399 32.0366 33.3615 32.3415L41.1431 34.2866C42.4014 34.6015 42.8347 36.1664 41.918 37.0814L40.2632 38.7365L43.5113 42.0114C44.1629 42.663 44.1629 43.7162 43.5113 44.3678L43.3679 44.5111C42.718 45.163 41.6631 45.163 41.0115 44.5111L37.7632 41.2362L36.0815 42.9195C35.1648 43.8346 33.6 43.4012 33.2865 42.1446L31.3399 34.3631ZM25.6663 34.9997C26.583 34.9997 27.333 35.7497 27.333 36.6664C27.333 37.583 26.583 38.3329 25.6663 38.3329H22.333C21.4164 38.3329 20.6665 37.583 20.6665 36.6664C20.6665 35.7497 21.4164 34.9997 22.333 34.9997H25.6663ZM27.333 28.3335C28.2495 28.3335 28.9995 29.0835 28.9995 30C28.9995 30.9165 28.2495 31.6665 27.333 31.6665H22.333C21.4164 31.6665 20.6665 30.9165 20.6665 30C20.6665 29.0835 21.4164 28.3335 22.333 28.3335H27.333ZM18.9996 18.3336C18.0797 18.3336 17.3331 19.0803 17.3331 20.0001C17.3331 20.9202 18.0798 21.6668 18.9996 21.6668C19.9198 21.6668 20.6664 20.9202 20.6664 20.0001C20.6664 19.0802 19.9197 18.3336 18.9996 18.3336Z",
    fill: "url(#paint0_linear_906_2182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_2182",
    x1: 21.6312,
    y1: 19.728,
    x2: 58.2861,
    y2: 40.8841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractionDesign);
export default __webpack_public_path__ + "static/media/interaction-design.23b00b417e3c1c435c2eb7a735aea59d.svg";
export { ForwardRef as ReactComponent };